module.exports = __webpack_public_path__ + "static/media/submenu.e3bc53cf.svg";